import { useProperty } from '@eti/providers';
import { PageBlock, Stack, vars } from '@etg/wings';
import { css } from '@eti/styles';
import MobileAppBanner from '../mobile-app-banner/MobileAppBanner';
import ImportantInformation from '../../widgets/important-information/ImportantInformation';
import PopularRoutes from '../popular-routes/PopularRoutes';
import PriceListWrapper from '../price-lists/PriceListWrapper';
import MainUniqueSellingPoint from './MainUniqueSellingPoint';
import InfoBoxContent from './InfoBoxContent';

const primaryBlockStyles = css`
  background-color: ${vars.colors.page.background.primary};
`;

const secondaryBlockStyles = css`
  background-color: ${vars.colors.page.background.secondary};
`;

interface StartPageDestinationPageContentProps {
  destination?: {
    name: string;
    iataCode: string;
  };
  isStartPage?: boolean;
  origin?: {
    name: string;
    iataCode: string;
  };
}

export const StartPageDestinationPageContent = ({
  destination,
  origin,
  isStartPage,
}: StartPageDestinationPageContentProps) => {
  const { p } = useProperty();

  return (
    <>
      {p('IbeClient.USP.Enabled') && <MainUniqueSellingPoint className={secondaryBlockStyles} />}
      <PageBlock className={primaryBlockStyles} withPaddingY>
        <Stack spacing={32}>
          <ImportantInformation />
          {p('IbeClient.InfoBox.Enabled') && <InfoBoxContent />}
          {p('IbeClient.MobileAppPromoBanner.Enabled') && (
            <MobileAppBanner isStartPage={isStartPage} />
          )}
          {p('DestinationPage.SemComponent.PriceLists.Enabled') && origin && destination && (
            <PriceListWrapper destination={destination} origin={origin} />
          )}
          {p('SeoComponent.PopularRoutes.Destinations') &&
            p('StartPage.SeoComponent.PopularRoutes.Enabled') && <PopularRoutes />}
        </Stack>
      </PageBlock>
    </>
  );
};
